import { render, staticRenderFns } from "./AppHeadline.vue?vue&type=template&id=511334ca&"
import script from "./AppHeadline.vue?vue&type=script&lang=js&"
export * from "./AppHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports